<template>
  	<div class="content">

      <div class="container-fluid" style="min-height:70vh;">
        <div class="row" style="overflow-y: auto;">
          	<div class="col-12" style="margin-top:40px;">

              <div v-if="loadingEndpointJSON">
                  <card class="strpied-tabled-with-hover" body-classes="">
                    <template class="card-body">
                      <div class="text-center col-12 col-sm-12 col-xl-8 col-lg-10 mx-auto" style="justify-content: center;margin-top:20px;">
                        <h4 style="margin-bottom: 30px">Loading quality assessment report...</h4>
                      </div>
                    </template>
                  </card>
              </div>

              <div v-else-if="errorEndpointJSON">
                <card class="strpied-tabled-with-hover" body-classes="">
                  <template class="card-body">
                    <div class="text-center col-12 col-sm-12 col-xl-8 col-lg-10 mx-auto" style="justify-content: center;margin-top:20px;">
                      <h2 style="color: #76BAC6; font-weight: bold;">Error loading quality assessment report</h2>
                      <h4>{{this.$route.params.json_url}} cannot be loaded or does not have a valid syntax.</h4>
                      <h4>Please ensure the URL is correct and try again.</h4>
                      <button v-show="isLogged" style="color: #fff;background-color: #6c757d;border: none; margin: 20px 0" class="btn" @click="$router.push('/')"><i class="fa fa-arrow-left"></i> Back to main page</button>
                    </div>
                  </template>
                </card>
              </div>

              <card v-else class="strpied-tabled-with-hover" body-classes="">
                <template slot="header" >
                  <div class="row hideInPDF" style="padding: 0px 10px;">
                    <div class="col-6" style="display:inline-flex;">
                      <button v-show="isLogged && !fromEndpoint" class="btn btn-default btn-simple" @click="gotoFull()"><i class="fa fa-arrow-left" aria-hidden="true"></i><span style="font-weight: bold;padding-top:5px;font-size:18px;" class="card-title">Back</span></button>
                    </div>
                    <div class="col-6 text-right mt-2 ">
                      <button v-show="isLogged" style="color: #fff;background-color: #6c757d;border: none;" class="btn" @click="refresh()"><i class="fa fa-refresh" style="padding-right:10px;" aria-hidden="true"></i> New Assessment</button>
                      <div class="btn-group">
                        <button id="downloadDropdown" style="color: #fff;background-color: #6c757d;border: none;margin-left: 15px;" class="btn dropdown-toggle" data-toggle="dropdown"><i class="fa fa-download" style="padding-right:10px;" aria-hidden="true" ></i> Download </button>
                        <ul id="downloadDropdownMenu" class="dropdown-menu">
                          <li><a role="button" @click="downloadJSON()"><i class="fa fa-file-alt" style="color: #455098; margin-right: 5px;"></i> JSON</a></li>
                          <li><a role="button" @click="downloadPNG()"><i class="fa fa-file-image-o" style="color: #459849; margin-right: 5px;"></i> PNG</a></li>
                          <li><a role="button" @click="downloadPDF()"><i class="fa fa-file-pdf-o" style="color: #984545; margin-right: 5px;"></i> PDF</a></li>
                        </ul>
                      </div>
                    </div>

                  </div>
                </template>

                <template class="card-body">

                  <div class="container-fluid mb-5">

                    <div class="row">
                      <div class="col">

                        <div style="max-width: 1200px; margin: 1em auto 0 auto; font-size: 0.9em; border-left: solid 1px lightgrey; padding-left: 0.6em;">
                          <div v-if="this.$store.state.report.meta.timestamp"> <span style="font-weight:bold;">Report date:</span> {{new Date(Math.floor(this.$store.state.report.meta.timestamp*1000)).toLocaleString()}}</div>
                          <div v-if="this.$store.state.report.meta.version"> <span style="font-weight:bold;">API version:</span> {{this.$store.state.report.meta.version}}</div>
                        </div>

                      </div>
                    </div>

                    <div class="row mt-3">
                      <div class="col d-flex justify-content-center">

                        <RepoData :assessmentType="getAssessmentType()" :repo="this.$store.state.report.repository[0]" />

                      </div>
                    </div>

                    <div class="row mt-5">
                      <div class="col">

                        <h2 style="font-weight:bold; max-width: 1200px; margin: 0 auto 0 auto;">Badge Report</h2>

                      </div>
                    </div>

                    <div class="row mt-3">

                      <div class="col d-flex justify-content-center">

                        <BadgeAchieved :badge="this.$store.state.report.badge" :permalink="this.$store.state.report.meta.report_permalink"/>

                      </div>
                    </div>

                    <div class="row mt-5">
                      <div class="col">

                        <BadgeResults :badgeCriteria="getBadgeCriteria()" :mapping_icon="mapping_icon" :mapping_criteria_name="mapping_criteria_name" />

                      </div>
                    </div>


                    <div class="row mt-5">
                      <div class="col">

                        <h2 style="font-weight:bold; max-width: 1200px; margin: 0 auto 0 auto;">Criteria Report</h2>

                      </div>
                    </div>

                    <div class="row mt-5">
                      <div class="col d-flex justify-content-center">

                        <CriteriaSummary :report="this.$store.state.report.report" :mapping_icon="mapping_icon" :mapping_criteria_name="mapping_criteria_name"/>

                      </div>
                    </div>

                  </div>


                  <div class="col-12 col-lg-8 col-xl-6 mx-auto">

                    <card v-for="(criteria, idx_criteria) in $store.state.report.report" :id="idx_criteria" :key="idx_criteria" style="padding:0px!important;">
                        <template slot='header' style="background-color:#E8E6E5!important;">
                          <div  style="padding-left:1.5rem;background-color:#E8E6E5!important; border-bottom:1px solid #dee2e6">
                            <!-- <div class="col-2">
                              <div style="text-align:right;margin-top:30px;">
                                <i style="color:#7C7572" class="fa fa-2x" :class="mapping_icon[index]?mapping_icon[index]:mapping_icon['default']" aria-hidden="true"></i>
                              </div>
                            </div> -->
                            <div class="row" style="margin-right:0px; margin-left:0px;">
                              <div class="col-10" style="padding-top:20px;">
                                  <p style="font-weight: 700; font-size:24px;"> <i style="margin-right: 50px;color:#7C7572; font-size:28px;" class="fa fa-2x" :class="mapping_icon[idx_criteria]?mapping_icon[idx_criteria]:mapping_icon['default']" aria-hidden="true"></i>{{ mapping_criteria_name[idx_criteria] ? mapping_criteria_name[idx_criteria] : idx_criteria }}</p>
                              </div>
                              <div class="col-2" style="padding-top:20px;">
                                <div v-if="criteria['valid'] == true" style="text-align:center;">
                                    <i style="color:#1BC10B;" class="fa fa-2x fa-check-circle" aria-hidden="true"></i>
                                </div>
                                <div v-else style="text-align:center;">
                                    <i style="color:red" class="fa fa-2x fa-times-circle" aria-hidden="true"></i>
                                </div>

                              </div>
                            </div>
                          </div>

                        </template>

                        <template class="card-body">

                          <div class="row" style="padding:0 20px;">
                            <div v-if="criteria['filtered_reason']">
                              <p v-for="(fr, z) in criteria['filtered_reason']" :key="z" style="margin-bottom:0px; font-size:12px; color:rgb(108, 117, 125)">
                                {{criteria['filtered_reason'][z]}}
                              </p>
                            </div>
                          </div>

                          <div v-for="(subcriteria, idx_subcriteria) in criteria['subcriteria']" :key="idx_subcriteria" class="subcriteria" style="padding: 10px; font-size:18px;">

                            <div class="row">
                              <div class="col-3">

                                <div v-if="getAssessmentType() === 'fair'">
                                  <div style="font-weight: bold">{{idx_subcriteria}}</div>
                                  <div style="font-weight: bold; padding-right: 10px;" :style="{color: getColorPoints(subcriteria['points'])}">{{subcriteria['points']}}%</div>
                                </div>

                                <div v-else>
                                  <i v-if="subcriteria['valid']" style="color:#1BC10B; padding-right: 40px" class="fa fa-check-circle"></i>
                                  <i v-else style="color:red; padding-right: 40px" class="fa fa-times-circle"></i>
                                  <span style="font-weight: bold">{{idx_subcriteria}}</span>
                                </div>

                              </div>
                              <div class="col-8"> {{subcriteria['description']}}
                                <svg v-if="subcriteria['valid'] === false && subcriteria.required_for_next_level_badge" fill="#de960f" viewBox="0 0 24 24" height="24" width="24" style="margin-left: 8px; margin-top: -5px" data-toggle="tooltip" data-placement="top" title="Required for achieving next level of badge">
                                  <path d="M12 22c3.859 0 7-3.141 7-7s-3.141-7-7-7c-3.86 0-7 3.141-7 7s3.14 7 7 7zm0-12c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm-1-8H7v5.518a8.957 8.957 0 0 1 4-1.459V2zm6 0h-4v4.059a8.957 8.957 0 0 1 4 1.459V2z"></path><path d="m10.019 15.811-.468 2.726L12 17.25l2.449 1.287-.468-2.726 1.982-1.932-2.738-.398L12 11l-1.225 2.481-2.738.398z"></path>
                                </svg>
                              </div>
                              <div class="col-1" style="padding-right: 34px;">
                                <span class="float-right">
                                  <button v-if="fair_principles_satisfied(idx_subcriteria, subcriteria).principles.length > 0" class="btn btn-link fair4rs-button" style="border:none; font-size:20px; padding: 0 0 0 14px; margin-bottom: 0" data-toggle="modal" data-target="#fairModal" @click="modalFair(idx_criteria, idx_subcriteria, subcriteria)">
                                    <img v-if="fair_principles_satisfied(idx_subcriteria, subcriteria).satisfied" src="../../static/fair_enabled.png" width="40px" alt="FAIR for Research Software" data-toggle="tooltip" data-placement="top" title="FAIR4RS">
                                    <img v-else src="../../static/fair_disabled.png" width="40px" alt="FAIR for Research Software" data-toggle="tooltip" data-placement="top" title="FAIR4RS">
                                  </button>
                                </span>
                              </div>
                            </div>

                            <div class="row evidence" v-for="(evidence, idx_evidence) in subcriteria['evidence']" :key="idx_evidence" style="margin-top: 10px; padding-bottom: 16px; font-size:17px;">
                              <div class="col-9 offset-1">
                                <i v-if="subcriteria['evidence'][idx_evidence]['valid']" style="color:#1BC10B;padding-right:30px;" class="fa fa-check" aria-hidden="true"></i>
                                <i v-else style="color:red;padding-right:30px;" class="fa fa-times" aria-hidden="true"></i>
                                <span style="color: #6c757d">{{ subcriteria['evidence'][idx_evidence]['message'] }}</span>
                              </div>
                              <div class="col-2 hideInPDF" style="padding-right: 34px;">
                                <span class="float-right">
                                  <button class="btn btn-link" style="border:none; font-size:20px; padding: 0;" data-toggle="modal" data-target="#infoModal" @click="modalInfo(idx_criteria, idx_subcriteria, subcriteria['evidence'][idx_evidence])">
                                    <i class="fa fa-info-circle" aria-hidden="true" style="color: royalblue;" data-toggle="tooltip" data-placement="top" title="More Info"></i>
                                  </button>
                                  <button v-if="subcriteria['valid'] === false" class="btn btn-link hint-button" style="border:none; font-size:20px; padding: 0 0 0 14px; margin-bottom: 0" data-toggle="modal" data-target="#hintModal" @click="modalHint(idx_criteria, idx_subcriteria, subcriteria['evidence'][idx_evidence]['message'], subcriteria.hint)">
                                    <i class="fa fa-lightbulb-o" aria-hidden="true" style="color: goldenrod;" data-toggle="tooltip" data-placement="top" title="Hint"></i>
                                  </button>
                                </span>
                              </div>

                            </div>

                          </div>

                        </template>

                      </card>

                  </div>


                </template>
              </card>



              <!-- Info Modal -->
              <div class="modal fade bd-example-modal-lg" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="infoModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content" style="background-color: #f4f4f4">
                    <div class="modal-header">

                      <div class="modal-title" id="infoModalLabel">
                        <i style="margin-right: 24px; transform: translate(0,3px); color:#7C7572; font-size:28px;" class="fa fa-2x" :class="mapping_icon[modalInfoData.criteria] ? mapping_icon[modalInfoData.criteria]:mapping_icon['default']" aria-hidden="true"></i>
                        <span style="font-size: 22px; font-weight:700;">{{mapping_criteria_name[modalInfoData.criteria]}}</span>
                        <div style="margin-left: 44px; margin-bottom: 5px; font-weight:700; font-size:18px;">{{$store.state.report.report[modalInfoData.criteria] ? $store.state.report.report[modalInfoData.criteria].subcriteria[modalInfoData.subcriteria].description:''}}</div>
                        <div style="font-size:18px;" >
                          <i v-if="modalInfoData.valid === true" style="color:#1BC10B; font-size: 28px; transform: translate(0,4px);" class="fa fa-check" aria-hidden="true"></i>
                          <i v-else style="color:red; font-size: 28px; transform: translate(0,3px);" class="fa fa-times" aria-hidden="true"></i>
                          <span style="margin-left: 24px;">{{modalInfoData.message}}</span>
                        </div>
                      </div>

                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body">
                      <card>

                        <div v-if="modalInfoData && modalInfoData['tool_selected']">
                          <div class="row" style="padding-left: 20px; padding-bottom: 6px;">
                            <span style="font-weight:700; margin-right: 6px;">Tool:</span> {{modalInfoData['tool'].name ? modalInfoData['tool'].name: ''}}
                            <a :href="modalInfoData['tool_selected']['ci'] ? modalInfoData['tool_selected']['ci']['url']:'#'" target="_blank" style="margin-left: 10px;" data-toggle="tooltip" data-placement="top" title="View Jenkins output"><img src="../../static/jenkins_logo.png" height="28px"/></a>
                          </div>
                          <div class="row" style="padding-left: 30px">
                            <span v-show="modalInfoData['tool_selected']['version']" style="padding:0.25em 0.6em; margin-right: 5px;" class="badge badge-primary">version: {{modalInfoData['tool']['version']}}</span>
                            <span v-show="modalInfoData['tool_selected']['docker'] &&  modalInfoData['tool_selected']['docker']['image']" style="padding:0.25em 0.6em; margin-right: 5px;" class="badge badge-secondary">image: {{modalInfoData['tool']['docker'] && modalInfoData['tool']['docker']['image'] ? modalInfoData['tool']['docker']['image'] : modalInfoData['tool']['docker'] && modalInfoData['tool']['docker']['dockerfile']?'Dockerfile':''}}</span>
                            <span v-show="modalInfoData['tool_selected']['lang'] && modalInfoData['tool_selected']['lang'] !== ''" style="padding:0.25em 0.6em; margin-right: 5px;" class="badge badge-success">lang: {{modalInfoData['tool']['lang']}}</span>
                          </div>
                        </div>

                        <div v-if="modalInfoData && modalInfoData['plugin']">
                          <div class="row" style="margin-top: 12px; padding-left: 20px; padding-bottom: 2px;">
                            <span style="font-weight:700; margin-right: 6px;">Plugin:</span> {{modalInfoData['plugin']['name'] ? modalInfoData['plugin']['name']:''}}
                          </div>
                          <div class="row" style="padding-left: 30px">
                            <span v-show="modalInfoData['plugin']['version']" style="padding:0.25em 0.6em; margin-right: 5px;" class="badge badge-primary">version: {{modalInfoData['plugin']['version']}}</span>
                          </div>
                        </div>

                        <div class="row" v-if="modalInfoData && modalInfoData['tool_selected'] && modalInfoData['tool_selected']['build_repo']" style="margin-top: 12px; padding-left: 20px;">
                          <span style="font-weight:700; margin-right: 6px;">Build repo:</span> <a :href="modalInfoData['tool_selected']['build_repo'] ? modalInfoData['tool_selected']['build_repo']:'#'" target="_blank" > {{modalInfoData && modalInfoData['tool'] && modalInfoData['tool']['build_repo'] ? modalInfoData['tool']['build_repo']:''}}</a>
                        </div>

                        <div v-if="modalInfoData && modalInfoData['standard']">
                          <div class="row" style="margin-top: 8px; padding-left: 20px; padding-bottom: 2px;">
                            <span style="font-weight:700; margin-right: 6px;">Standard:</span> <a :href="modalInfoData['standard']['url'] ? modalInfoData['standard']['url']:'#'" target="_blank" >{{modalInfoData && modalInfoData['standard'] && modalInfoData['standard']['title'] ? modalInfoData['standard']['title']:''}}</a>
                          </div>
                          <div class="row" style="padding-left: 30px">
                            <span v-show="modalInfoData['standard']['version']" style="padding:0.25em 0.6em; margin-right: 5px;" class="badge badge-primary">version: {{modalInfoData['standard']['version']}}</span>
                          </div>
                        </div>

                        <div v-if="showEditor" style="padding-top:2rem; height:40vh;overflow-y: auto;">
                          <editor editor-id="editor_modal" lang="json" :content="modalUnstructured" key="editor_modal" ></editor>
                        </div>

                      </card>
                   </div>

                    <div class="modal-footer" style="justify-content: end;">
                      <button type="button" class="btn btn-secondary" style="color: #fff!important;background-color: #6c757d!important;border-color: #6c757d!important;" data-dismiss="modal">Close</button>
                      <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                    </div>
                  </div>
                </div>
              </div>



              <!-- Hint Modal -->
              <div class="modal fade bd-example-modal-lg" id="hintModal" tabindex="-1" role="dialog" aria-labelledby="hintModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content" style="background-color: #f4f4f4">
                    <div class="modal-header">

                      <div class="modal-title" id="hintModalLabel">
                        <i style="margin-right: 24px; transform: translate(0,3px); color:#7C7572; font-size:28px;" class="fa fa-2x" :class="mapping_icon[modalHintData.criteria] ? mapping_icon[modalHintData.criteria]:mapping_icon['default']" aria-hidden="true"></i>
                        <span style="font-size: 22px; font-weight:700;">{{mapping_criteria_name[modalHintData.criteria]}}</span>
                        <div style="margin-left: 44px; margin-bottom: 5px; font-weight:700; font-size:18px;">{{$store.state.report.report[modalHintData.criteria] ? $store.state.report.report[modalHintData.criteria].subcriteria[modalHintData.subcriteria].description:''}}</div>
                        <div style="font-size:18px;" >
                          <i style="color:red; font-size: 28px; transform: translate(0,3px);" class="fa fa-times" aria-hidden="true"></i>
                          <span style="margin-left: 24px;">{{modalHintData.evidence}}</span>
                        </div>
                      </div>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body">
                        <card>
                          <div style="font-weight: 700; font-size: 22px; margin-bottom: 12px;"><i class="fa fa-lightbulb-o" aria-hidden="true" style="color: gold; font-size: 36px; margin-right: 16px;"></i> Hint</div>
                          <div v-html="modalHintData.hint"></div>
                        </card>
                    </div>

                    <div class="modal-footer" style="justify-content: end;">
                      <button type="button" class="btn btn-secondary" style="color: #fff!important;background-color: #6c757d!important;border-color: #6c757d!important;" data-dismiss="modal">Close</button>
                    </div>
                  </div>
                </div>
              </div>



              <!-- FAIR4RS Modal -->
              <div class="modal fade bd-example-modal-lg" id="fairModal" tabindex="-1" role="dialog" aria-labelledby="fairModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content" style="background-color: #f4f4f4">
                    <div class="modal-header">

                      <div class="modal-title" id="fairModalLabel">
                        <img v-if="modalFairData.fair_principles && modalFairData.fair_principles.satisfied" style="margin-right: 4px; transform: translate(0,-3px);" src="../../static/fair_enabled.png" width="58px" alt="FAIR for Research Software">
                        <img v-else style="margin-right: 4px; transform: translate(0,-3px);" src="../../static/fair_disabled.png" width="58px" alt="FAIR for Research Software">
                        <span style="font-size: 22px; font-weight:700;"> for Research Software</span>
                      </div>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body">
                      <card style="padding: 0.5em">
                        <div style="font-size:18px">

                          <span v-if="modalFairData.fair_principles && modalFairData.fair_principles.satisfied"><b>{{modalFairData.subcriteria_id}}</b> satisfies the FAIR4RS principles:</span>
                          <span v-else><b>{{modalFairData.subcriteria_id}}</b> doesn't satisfy all the FAIR4RS principles:</span>
                        </div>

                        <div style="margin-left: 20px; margin-top: 1em; font-size:18px; line-height: 1.6em;">
                          <div v-for="principle in modalFairData.fair_principles && modalFairData.fair_principles.principles">
                            <div style="margin-bottom: 0.6em">
                              <i v-if="principle.satisfied" style="color:#1BC10B; font-size: 24px; transform: translate(0, 2px);" class="fa fa-check" aria-hidden="true"></i>
                              <i v-else style="color:#c10b0b; font-size: 24px; transform: translate(3px, 2px);" class="fa fa-times" aria-hidden="true"></i>
                              <span style="font-weight:700; margin-left: 14px; margin-right: 4px">{{ principle.name }}</span> {{ principle.description }}
                            </div>
                          </div>
                        </div>
                      </card>
                      <div style="margin-left: 8px;">More info at <a href="https://www.nature.com/articles/s41597-022-01710-x" target="_blank">Introducing the FAIR Principles for research software</a></div>
                    </div>

                    <div class="modal-footer" style="justify-content: end;">
                      <button type="button" class="btn btn-secondary" style="color: #fff!important;background-color: #6c757d!important;border-color: #6c757d!important;" data-dismiss="modal">Close</button>
                    </div>
                  </div>
                </div>
              </div>





          </div>
        </div>
      </div>

  	</div>
</template>
<script>

  import Card from 'src/components/Cards/Card.vue'
  import Services from '../services/services'
  import Editor from './AceEditor'
  import RepoData from 'src/components/AssessmentReport/RepoData';
  import CriteriaSummary from 'src/components/AssessmentReport/CriteriaSummary';
  import BadgeResults from 'src/components/AssessmentReport/BadgeResults';
  import BadgeAchieved from "@/components/AssessmentReport/BadgeAchieved";
  import html2canvas from 'html2canvas';
  import jsPDF from 'jspdf';
  import TopNavbar from "@/layout/TopNavbar.vue";
  import ContentFooter from "@/layout/ContentFooter.vue";
  import store from "@/store";

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      RepoData,
      CriteriaSummary,
      BadgeResults,
      BadgeAchieved,
      Card,
      'editor': Editor,
    },
    mixins: [Services],
    data () {
      return {
        isLogged: store.state.isLogged,
        fromEndpoint: Boolean(this.$route.params.json_url),
        loadingEndpointJSON: true,
        errorEndpointJSON: false,
        modalInfoData: {},
        modalHintData: {},
        modalFairData: {},
        editor: '',
        modalUnstructured:'',
        showEditor:false,
        mapping_icon:{
          'default': 'fa-certificate',
          'QC.Acc':'fa-certificate',
          'QC.Lic':'fa-id-card',
          'QC.Sty':'fa-bullseye',
          'QC.Met':'fa-database',
          'QC.Uni':'fa-cogs',
          'QC.Doc':'fa-book',
          'QC.Sec':'fa-lock',
          'QC.Ver':'fa-code-fork',
          'QC.FAIR':'fa-certificate',
          'QC.Fun':'fa-filter',
          'SvcQC.Dep':'fa-rocket',
          'SvcQC.Fun':'fa-filter',
          'SvcQC.Sec':'fa-lock',
          'SvcQC.Doc':'fa-book',
          'SvcQC.Api':'fa-desktop',
          'SvcQC.Per':'fa-calendar-check',
          'SvcQC.Int':'fa-arrows-alt'
        },
        mapping_criteria_name:{
          'QC.Acc':'Code Accessibility',
          'QC.Lic':'Licensing',
          'QC.Sty':'Code Style',
          'QC.Met':'Code metadata',
          'QC.Uni':'Unit Testing',
          'QC.Har':'Test Harness',
          'QC.Tdd':'Test-Driven Development',
          'QC.Doc':'Documentation',
          'QC.Sec':'Security',
          'QC.Wor':'Code Workflow',
          'QC.Ver':'Versioning',
          'QC.Man':'Code Management',
          'QC.Rev':'Code Review',
          'QC.Del':'Automated Delivery',
          'QC.Dep':'Automated Deployment',
          'QC.FAIR':'FAIRness level of Digital Objects',
          'QC.Fun':'Functional',
          'SvcQC.Dep':'Service Deployment',
          'SvcQC.Fun':'Service Functional Testing',
          'SvcQC.Sec':'Security Testing (DAST)',
          'SvcQC.Doc':'Service Documentation',
          'SvcQC.Api':'API Testing',
          'SvcQC.Per':'Performance Testing',
          'SvcQC.Int':'Integration Testing',
          'RDA_F1_01M':'Metadata is identified by a persistent identifier',
          'RDA_F1_01D':'Data is identified by a persistent identifier',
          'RDA_F1_02M':'Metadata is identified by a globally unique identifier',
          'RDA_F1_02D':'Data is identified by a globally unique identifier',
          'RDA_F2_01M':'Rich metadata is provided to allow discovery',
          'RDA_F3_01M':'Metadata includes the identifier for the data',
          'RDA_F4_01M':'Metadata is offered in such a way that it can be harvested and indexed',
          'RDA_A1_01M':'Metadata contains information to enable the user to get access to the data',
          'RDA_A1_02M':'Metadata can be accessed manually (i.e. with human intervention)',
          'RDA_A1_02D':'Data can be accessed manually (i.e. with human intervention)',
          'RDA_A1_03M':'Metadata identifier resolves to a metadata record',
          'RDA_A1_03D':'Data identifier resolves to a digital object',
          'RDA_A1_04M':'Metadata is accessed through standardised protocol',
          'RDA_A1_04D':'Data is accessible through standardised protocol',
          'RDA_A1_05D':'Data can be accessed automatically (i.e. by a computer program)',
          'RDA_A1_1_01M':'Metadata is accessible through a free access protocol',
          'RDA_A1_1_01D':'Data is accessible through a free access protocol',
          'RDA_A1_2_01D':'Data is accessible through an access protocol that supports authentication and authorisation',
          'RDA_A2_01M':'Metadata is guaranteed to remain available after data is no longer available',
          'RDA_I1_01M':'Metadata uses knowledge representation expressed in standardised format',
          'RDA_I1_01D':'Data uses knowledge representation expressed in standardised format',
          'RDA_I1_02M':'Metadata uses machine-understandable knowledge representation',
          'RDA_I1_02D':'Data uses machine-understandable knowledge representation',
          'RDA_I2_01M':'Metadata uses FAIR-compliant vocabularies',
          'RDA_I2_01D':'Data uses FAIR-compliant vocabularies',
          'RDA_I3_01M':'Metadata includes references to other metadata',
          'RDA_I3_01D':'Data includes references to other data',
          'RDA_I3_02M':'Metadata includes references to other data',
          'RDA_I3_02D':'Data includes qualified references to other data',
          'RDA_I3_03M':'Metadata includes qualified references to other metadata',
          'RDA_I3_04M':'Metadata include qualified references to other data',
          'RDA_R1_01M':'Plurality of accurate and relevant attributes are provided to allow reuse',
          'RDA_R1_1_01M':'Metadata includes information about the licence under which the data can be reused',
          'RDA_R1_1_02M':'Metadata refers to a standard reuse licence',
          'RDA_R1_1_03M':'Metadata refers to a machine-understandable reuse licence',
          'RDA_R1_2_01M':'Metadata includes provenance information according to community-specific standards',
          'RDA_R1_2_02M':'Metadata includes provenance information according to a crosscommunity language',
          'RDA_R1_3_01M':'Metadata complies with a community standard',
          'RDA_R1_3_01D':'Data complies with a community standard',
          'RDA_R1_3_02M':'Metadata is expressed in compliance with a machineunderstandable community standard',
          'RDA_R1_3_02D':'Data is expressed in compliance with a machine-understandable'
        }
      }
    },
    watch:{},
    methods:{
      getColorPoints(points){
        if (points === 100) return '#19AF0B'
        if (points >= 80) return '#97CB00'
        if (points >= 50) return '#FEC000'
        if (points >= 30) return '#F98604'
        return '#EF0000'
      },
      modalInfo(criteria, subcriteria, info){
        this.modalInfoData = info;
        this.modalInfoData.criteria = criteria;
        this.modalInfoData.subcriteria = subcriteria;

        // if(crit != '' && type != '' && tool != ''){
        //   for(var i in this.$store.state.report['report'][crit]['validator_data']['tool'][type]){
        //     if(tool == this.$store.state.report['report'][crit]['validator_data'][type]['tool'][i]['name']){
        //       this.modalInfoData = this.$store.state.report['report'][crit]['validator_data']['tool'][type][i]
        //     }
        //   }
        // }
        if(this.modalInfoData['data_unstructured'] && Object.keys(this.modalInfoData['data_unstructured']).length > 0){
          this.showEditor = true;
          this.modalUnstructured = JSON.stringify(this.modalInfoData['data_unstructured'], null, '\t')
        }else{
          this.showEditor = false;
          this.modalUnstructured = '';
        }
        console.log(this.modalInfoData)
      },
      modalHint(criteria, subcriteria, evidence, hint){
        this.modalHintData = {
          criteria: criteria,
          subcriteria: subcriteria,
          evidence: evidence,
          hint: hint
        };
        console.log(this.modalHintData)
      },
      modalFair(criteria_id, subcriteria_id, subcriteria){
        this.modalFairData = {
          criteria_id: criteria_id,
          subcriteria_id: subcriteria_id,
          subcriteria: subcriteria,
          fair_principles: this.fair_principles_satisfied(subcriteria_id, subcriteria)
        }

      },
      fair_principles_satisfied(idx_subcriteria, subcriteria) {

        let fair_principles = {satisfied: undefined, principles: []}

        if (idx_subcriteria === 'QC.Acc01') {
          fair_principles.principles.push({name: "A1", description: "Software is retrievable by its identifier using a standardised communications protocol", satisfied: subcriteria.valid})
          fair_principles.principles.push({name: "A1.1", description: "The protocol is open, free, and universally implementable", satisfied: this.$store.state.report.repository[0].url.startsWith("https://")})
          fair_principles.principles.push({name: "A1.2", description: "The protocol allows for an authentication and authorization procedure, where necessary", satisfied: this.$store.state.report.repository[0].url.startsWith("https://")})
          fair_principles.satisfied = fair_principles.principles.every((principle => principle.satisfied))
        } else if (idx_subcriteria === 'QC.Lic01') {
          fair_principles.principles.push({name: "R1.1", description: "Software is given a clear and accessible license", satisfied: subcriteria.valid})
          fair_principles.satisfied = fair_principles.principles.every((principle => principle.satisfied))
        } else if (idx_subcriteria === 'QC.Met01') {
          fair_principles.principles.push({name: "F2", description: "Software is described with rich metadata", satisfied: subcriteria.valid})
          fair_principles.satisfied = fair_principles.principles.every((principle => principle.satisfied))
        } else if (idx_subcriteria === 'QC.Ver01.0') {
          fair_principles.principles.push({name: "F1.2", description: "Different versions of the software are assigned distinct identifiers", satisfied: subcriteria.valid})
          fair_principles.satisfied = fair_principles.principles.every((principle => principle.satisfied))
        }

        return fair_principles
      },
      gotoFull() {
        this.$router.push({name: 'full_assessment'});
      },
      refresh() {
        this.$router.push({name: 'full_assessment'});
      },
      getAssessmentType() {
        if (this.$store.state.report.badge.software) return "software"
        if (this.$store.state.report.badge.services) return "services"
        if (this.$store.state.report.badge.fair) return "fair"
      },
      downloadJSON() {

        let a = document.createElement("a");
        a.style.display = "none"
        let json = JSON.stringify(this.$store.state.report, null, "\t");
        let blob = new Blob([json], {type: "octet/stream"});
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "SQAaaS Report - " + (this.getAssessmentType() === 'fair' ? this.$store.state.report.repository[0].name.match(/\d+\/\d+$/)[0] : this.$store.state.report.repository[0].name) + ".json"
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();

      },
      downloadPNG() {

        $('#downloadDropdown').dropdown('hide')

        html2canvas(document.body, {useCORS: true}).then(canvas => {
          let a = document.createElement("a");
          a.style.display = "none"
          canvas.toBlob(blob => {
            a.href = window.URL.createObjectURL(blob);
            a.download = "SQAaaS Report - " + (this.getAssessmentType() === 'fair' ? this.$store.state.report.repository[0].name.match(/\d+\/\d+$/)[0] : this.$store.state.report.repository[0].name) + ".png"
            a.click();
            window.URL.revokeObjectURL(a.href);
            a.remove();
          })
        });

      },
      downloadPDF() {

        $('#downloadDropdown').dropdown('hide')

        // Change URL link title
        let title_href = $('header .title a:has(.name)').attr('href')
        $('header .title a:has(.name)').attr('href', location.origin)

        // .hideInPDF are elements not to shown in the PDF
        $('.hideInPDF').hide()

        // .linkInPDF are <a> elements to shown as links in the PDF
        let links = []
        $(".linkInPDF").each(function( index ) {
          let linkRect = this.getBoundingClientRect()
          links.push({
            rect: {left: linkRect.left*1.01, top: linkRect.top, width: linkRect.right - linkRect.left, height: linkRect.bottom - linkRect.top},
            url : this.href
          })
        });

        html2canvas(document.body, {useCORS: true}).then(canvas => {
          let pdf = new jsPDF({unit: 'px', format: [canvas.width, canvas.height], compress: true});
          pdf.addImage({imageData: canvas, format: 'jpg', width: canvas.width, height: canvas.height});

          links.forEach(function(link){
            pdf.link(link.rect.left, link.rect.top, link.rect.width, link.rect.height, {url: link.url});
          })

          pdf.save("SQAaaS Report - " + (this.getAssessmentType() === 'fair'? this.$store.state.report.repository[0].name.match(/\d+\/\d+$/)[0] : this.$store.state.report.repository[0].name) +".pdf");
        });

        // Restore changes
        $('.hideInPDF').show()
        $('header .title a:has(.name)').attr('href', title_href)

      },

      getBadgeCriteria(){
        return this.$store.state.report.badge.software && this.$store.state.report.badge.software.criteria ||
               this.$store.state.report.badge.services && this.$store.state.report.badge.services.criteria ||
               this.$store.state.report.badge.fair && this.$store.state.report.badge.fair.criteria
      }

    },

    created(){

      this.$watch( // Watch if route params have changed
        () => this.$route.params,
        () => {
          this.loadingEndpointJSON = true
          this.errorEndpointJSON = false

          let _this = this; // Allow access "this" from promise

          if(this.$route.params.json_url){ // By endpoint
            $.getJSON(this.$route.params.json_url, (json) => {
              if(!json.repository || !json.report || !json.badge) _this.errorEndpointJSON = true
              else this.$store.state.report = json
            })
            .fail(function() {
              _this.errorEndpointJSON = true
            })
            .always(function(){
              _this.loadingEndpointJSON = false
            })
          }
          else{ // By interface
            this.loadingEndpointJSON = false
          }
        },
        { immediate: true }
      )

    },

   mounted(){

     console.log("---> store.state.report <---")
     console.log(this.$store.state.report)
     this.$eventHub.$emit('steps', 5);

     //if(this.$route.params.json_url) history.replaceState({}, null, '/full-assessment/report');  // Remove the JSON URL from the browser address bar

     $('[data-toggle="tooltip"]').tooltip()
     $('#infoModal').on('shown.bs.modal', () => { $('[data-toggle="tooltip"]').tooltip() });

  }
}
</script>
<style scoped>

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: .5rem 1rem;
  background-color:#73bbdc;
}

.navbar-brand {
  display: inline-block;
  padding-top: .3rem;
  padding-bottom: .3rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}

.navbar-brand img {
  max-width: 160px;
  -webkit-filter: brightness(0) invert(1);
  filter: brightness(0) invert(1);
}

.navbar>.container, .navbar>.container-fluid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.btn-login {
  color: #fff;
  font-weight: 700;
  border: 1px solid #fff;
  padding: .375rem 2rem;
  font-size: 1.25rem;
  line-height: 1.6;
  border-radius: 5px;
}

.btn-login:hover {
  color: #AB0720;
  border-color: #AB0720;
  border-radius: 5px;
}

.text-white {
  color: #fff!important;
}


.custom-label{
  padding-top:5px;
  padding-left:20px;
  color: #9A9A9A;

}

#downloadDropdownMenu{
  position: absolute;
  top: 100%!important;
  left: 10px!important;
  z-index: 1000;
  min-width: 160px;
  padding: 4px 0;
  margin-top: 2px;
  font-size: 14px;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
}
#downloadDropdownMenu > li:hover {
  background-color: #eeeeee;
}
#downloadDropdownMenu > li > a {
  display: block;
  padding: 4px 20px;
  color: #333;
}


.subcriteria:not(:last-child) .hint-button{
  margin-bottom: 10px;
}

.subcriteria:not(:last-child) .evidence:last-child{
  border-bottom: solid 1px #ccc;
}



input[type=number]::-webkit-inner-spin-button {
  opacity: 1;
}

.no-margin{
  margin:0px!important;
}

.custom-append-button {
  padding-top: 0px !important;
  padding-bottom: 0.38rem !important;
  padding-left:0.75rem !important;
  padding-right:0.75rem !important;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 400;
    /* line-height: 1.5; */
    color: #495057;
    /* text-align: center; */
    /* white-space: nowrap; */

    border: none;

    height: 40px;
}

.btn-info {
    border-color: #1185EB;
    color: #1185EB;
}

.btn-next {
    background-color: #1DC7EA !important;
    color: black !important;
    padding:1rem 0 1rem 0;
    font-weight: bold;
    border: 2px solid black;
  }

  .btn-next-back{
    width: 20%!important;
  }

.btn-back{
  padding:1rem 0 1rem 0;
  background-color:#ccc!important;
  margin-right:10%;
  font-weight: bold;
  border: 2px solid black;

}
.custom-div-append {
  padding:0px 0px 0px 0px;
  margin:0px;
  margin-left: -3px;
}




@media (max-width: 576px) {
  .container-fluid{
    padding-left: 0px!important;
    padding-right: 0px!important;
  }


 }

 .accordion-head i{
    font-size: 1.5em;
    float: right;
}

.accordion-head > .collapsed > i:before{
    content: "\f105";
}

@media (min-width: 992px){
    .col-lg-10 {
        -ms-flex: 0 0 83.333333%;
        -webkit-box-flex: 0;
        flex: 0 0 83.333333%;
        max-width: 100%;
  }
 }

 @media (min-width: 1200px) {
    .col-lg-10 {
        -ms-flex: 0 0 83.333333%;
        -webkit-box-flex: 0;
        flex: 0 0 83.333333%;
        max-width: 70%;
    }
  }

  .custom-table-title{
  padding-top:5px;
  /* padding-left:20px; */
  text-transform: uppercase;
  font-size:16px;
  color:black;
  font-weight:700;

}

.badgr-badge img{
  height: 300px!important;
  width: 300px!important;
}

.card .card-header{
 padding: 0px!important
}

.no-margin-card{
  padding-top: 0px!important;
}

.modal-dialog{
  transform:none!important;
}
</style>

